(function (drupalSettings) {
  //Scroll to: data-scroll-to data-target
  const anchorScrollTo = () => {
    const scrollToElements = document.querySelectorAll('[data-scroll-to]');

    const clickEvent = (event) => {
      event.preventDefault();

      const dataTarget = event.target.getAttribute('data-target');
      document.querySelector(dataTarget).scrollIntoView();
    }

    scrollToElements.forEach((elem) => {
      elem.addEventListener('click', clickEvent);
      // elem.addEventListener('tap', clickEvent);
    });

  }

  const changeDesktopAppUrl = () => {
    if (window.todesktop) {
      const linkElements = document.querySelectorAll('.ch-app-link');
      const desktopAppUrl = drupalSettings.fxi_theme?.desktopAppUrl;

      const updateLink = function(elem) {
        let newHref = desktopAppUrl;
        const params = elem.getAttribute("href").split('?')[1];

        if (params) newHref += '?' + params;

        elem.href = newHref;
        elem.removeAttribute('target');
      }

      desktopAppUrl && linkElements && linkElements.forEach((elem) => {
        updateLink(elem);
      });

      const _a = document.querySelectorAll('a[target="_blank"]');
      desktopAppUrl && _a && _a.forEach((_link) => {
        _link.setAttribute('target', '_self');
      })

    }
  }

  const adjustSearchAction = () => {
    if ((window.location.host.includes("forextime.com") || window.location.host.includes("staging.fxtm"))
      && !window.location.pathname.includes("zh-") && !window.location.host.includes("china")) {
      let header_search = document.getElementsByClassName("header_search-form")[0];
      let action = header_search.getAttribute('action');
      header_search.setAttribute('action', '/zh' + action);
    }
  }

  adjustSearchAction();
  anchorScrollTo();
  changeDesktopAppUrl();

})(drupalSettings);